<template>
  <div class="queue-task-list">
    <div class="task-section" v-if="storageStore.activeTasks.length > 0">
      <div class="section-header">進行中のタスク</div>
      <QueueTaskItem 
        v-for="task in storageStore.activeTasks" 
        :key="task.id" 
        :task="task"
        @cancel="cancelTask"
        @retry="retryTask"
      />
    </div>
    
    <div class="task-section" v-if="storageStore.completedTasksForDisplay.length > 0">
      <div class="section-header">完了済み</div>
      <QueueTaskItem 
        v-for="task in storageStore.completedTasksForDisplay" 
        :key="task.id" 
        :task="task"
        :show-actions="false"
      />
    </div>

    <div class="empty-state" v-if="storageStore.isQueueEmpty">
      <div class="empty-icon">📂</div>
      <div class="empty-text">タスクはありません</div>
    </div>
  </div>
</template>

<script setup>
import { useStorageStore } from '@/stores/storageStore'
import QueueTaskItem from './QueueTaskItem.vue'

const storageStore = useStorageStore()

const cancelTask = (taskId) => {
  storageStore.cancelTask(taskId)
}

const retryTask = (taskId) => {
  const task = storageStore.taskQueue.find(t => t.id === taskId)
  if (task) {
    storageStore.retryTask(task)
  }
}
</script>

<style scoped>
.queue-task-list {
  max-height: 300px;
  overflow-y: auto;
  border-bottom: 1px solid #e9ecef;
}

.task-section {
  padding: 8px 0;
}

.task-section:not(:last-child) {
  border-bottom: 1px solid #f1f3f4;
}

.section-header {
  font-size: 12px;
  font-weight: 600;
  color: #6c757d;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  padding: 8px 16px 4px;
  background-color: #f8f9fa;
  margin: 0 0 4px;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px 16px;
  color: #6c757d;
}

.empty-icon {
  font-size: 32px;
  margin-bottom: 8px;
  opacity: 0.5;
}

.empty-text {
  font-size: 14px;
  font-weight: 500;
}

/* スクロールバーのスタイル */
.queue-task-list::-webkit-scrollbar {
  width: 6px;
}

.queue-task-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 3px;
}

.queue-task-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 3px;
}

.queue-task-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}
</style>